module.exports = __webpack_public_path__ + "static/media/Tombeau-cover.2c810508.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Themes/Tombeau/Tombeau-cover.jpg
// module id = 601
// module chunks = 0